import './flash.scss';

const FLASH_CLASS_NAME = 'flash--navigation';

export default function highlight(targetId) {
  const target = document.getElementById(targetId);

  if (!target) return;

  // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
  target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  target.classList.add(FLASH_CLASS_NAME);
  setTimeout(() => target.classList.remove(FLASH_CLASS_NAME), 4000);
}
